var H = Object.defineProperty;
var P = (s, e, t) => e in s ? H(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var n = (s, e, t) => P(s, typeof e != "symbol" ? e + "" : e, t);
import { defineStore as q } from "pinia";
import { defineComponent as R, resolveComponent as f, openBlock as w, createBlock as b, unref as l, withCtx as g, createVNode as E, createElementVNode as h, toDisplayString as x, createElementBlock as I, Fragment as T, renderList as V, normalizeClass as B, createTextVNode as F } from "vue";
class d {
  constructor() {
    n(this, "callbackList");
    this.callbackList = [];
  }
  AddCallback(e) {
    this.callbackList.push(e);
  }
  RemoveCallback(e) {
    this.callbackList.forEach((t, o) => {
      t === e && this.callbackList.splice(o, 1);
    });
  }
  ClearCallbacks() {
    this.callbackList = [];
  }
  CallbackCount() {
    return this.callbackList.length;
  }
  Execute(...e) {
    this.callbackList.forEach((t) => {
      t.call(t, e);
    });
  }
}
class L {
  constructor(e, t) {
    n(this, "ExceptionId");
    n(this, "Message");
    this.ExceptionId = e, this.Message = t;
  }
}
class y {
  constructor() {
    n(this, "HandlePromiseError", (e) => {
      this.HandleError(JSON.stringify(e.promise), JSON.stringify(e.reason), -1, -1, void 0);
    });
    n(this, "HandlerVueError", (e) => {
      const t = () => {
      };
      return k.executeMethod(
        "fw4.ClientErrorSave",
        {
          ExceptionData: JSON.stringify(e)
        },
        t
      ), !0;
    });
    n(this, "HandleError", (e, t, o, i, a) => {
      let c = window.Error(), r = {
        event: JSON.stringify(e),
        data: c.message,
        stack: c.stack ? c.stack : "",
        cause: JSON.stringify(c.cause),
        source: t || "",
        lineno: o || -1,
        colno: i || -1,
        error: a ? JSON.stringify(a) : ""
      };
      const u = () => {
      };
      k.executeMethod(
        "fw4.ClientErrorSave",
        {
          ExceptionData: JSON.stringify(r)
        },
        u
      );
    });
  }
  static get Instance() {
    return this.singletonInstance || (this.singletonInstance = new this());
  }
  registerGlobalHandler() {
    window.onerror = this.HandleError, window.addEventListener("unhandledrejection", this.HandlePromiseError);
  }
}
n(y, "singletonInstance");
y.Instance;
class O {
  constructor() {
    n(this, "OnMessageReceived");
    n(this, "requestPath", "/appinvoke");
    n(this, "httpRequest");
    n(this, "makeRequest", (e) => {
      this.httpRequest.open("POST", this.requestPath, !0), this.httpRequest.setRequestHeader("Content-type", "application/json"), this.httpRequest.send(e);
    });
    n(this, "makeUpload", (e) => {
      this.httpRequest.open("POST", this.requestPath, !0), this.httpRequest.send(e);
    });
    n(this, "processError", () => {
    });
    n(this, "processRequest", (e) => {
      this.httpRequest.readyState === 4 && this.httpRequest.status === 200 && this.OnMessageReceived.Execute(this.httpRequest.responseText);
    });
    this.OnMessageReceived = new d(), this.httpRequest = new XMLHttpRequest(), this.httpRequest.onerror = this.processError, this.httpRequest.onreadystatechange = this.processRequest;
  }
}
class A {
  constructor() {
    n(this, "OnSocketConnected");
    n(this, "OnAuthenticationFailed");
    n(this, "OnMessageReceived");
    n(this, "OnSocketDisconnected");
    n(this, "OnSocketError");
    n(this, "isConnected", !1);
    n(this, "requestPath");
    n(this, "socket");
    n(this, "socketReconnectCount", 0);
    n(this, "pingInterval", 5e3);
    // 5 sec
    n(this, "pingHandle", null);
    n(this, "pongInterval", this.pingInterval * 2);
    n(this, "pongHandle", null);
    n(this, "reconnectHandle", null);
    n(this, "shouldReconnect", !0);
    // public connectSocket = () => {     
    //     if (this.reconnectHandle != null) {
    //         window.clearTimeout(this.reconnectHandle);
    //         this.reconnectHandle = null;   
    //     }
    //     try {
    //         this.socket = new WebSocket(this.requestPath);
    //         // this.socket.onopen = this.socketOpened;
    //         this.socket.onclose = this.socketClosed;
    //         this.socket.onerror = this.socketError;
    //         this.socket.onmessage = this.socketAuthenticationCallback;
    //         this.isConnected = false;
    //     } catch(e) {
    //         this.socket = null;
    //         this.isConnected = false;
    //         this.doReconnect();
    //     }
    // }
    n(this, "connectSocket", () => new Promise((e, t) => {
      this.reconnectHandle != null && (window.clearTimeout(this.reconnectHandle), this.reconnectHandle = null);
      try {
        this.socket = new WebSocket(this.requestPath), this.socket.onopen = (o) => {
          this.socketOpened(o), e();
        }, this.socket.onclose = (o) => {
          this.socketClosed(o), this.isConnected || t(new Error("WebSocket connection failed."));
        }, this.socket.onerror = (o) => {
          this.socketError(o);
        }, this.socket.onmessage = this.socketMessageReceived;
      } catch (o) {
        this.socket = null, this.isConnected = !1, this.OnAuthenticationFailed.Execute(), this.doReconnect(), t(o);
      }
    }));
    n(this, "doReconnect", () => {
      if (this.reconnectHandle == null) {
        var e = this.getReconnectTimeout();
        console.log("WebSocketClient - error connecting ... reconnecting in " + e.toString() + "ms"), this.reconnectHandle = window.setTimeout(this.connectSocket, e);
      }
    });
    n(this, "getReconnectTimeout", () => 3e3 + Math.round(Math.random() * 5e3));
    n(this, "disconnectSocket", () => {
      this.pongHandle != null && window.clearTimeout(this.pongHandle), this.pingHandle != null && window.clearTimeout(this.pingHandle), this.socket != null && (this.isConnected = !1, this.socket.close()), this.shouldReconnect && this.doReconnect();
    });
    n(this, "sendMessage", (e) => {
      this.socket != null && this.socket.send(e);
    });
    n(this, "socketOpened", (e) => {
      this.OnSocketConnected.Execute(), this.isConnected = !0, this.connectionPing();
    });
    n(this, "socketClosed", (e) => {
      this.pongHandle != null && window.clearTimeout(this.pongHandle), this.pingHandle != null && window.clearTimeout(this.pingHandle), this.isConnected = !1, this.OnSocketDisconnected.Execute(), console.log("WebSocketClient - socket closed"), this.shouldReconnect && this.doReconnect();
    });
    n(this, "socketError", (e) => {
      this.shouldReconnect = !0, this.disconnectSocket();
    });
    n(this, "socketMessageReceived", (e) => {
      this.pingHandle != null && window.clearTimeout(this.pingHandle), e.data == "AUTHTOKEN_INVALID" ? (this.shouldReconnect = !1, this.disconnectSocket()) : (e.data == "PONG" ? (window.clearTimeout(this.pongHandle), this.pongHandle = null) : this.OnMessageReceived.Execute(e.data), this.pingHandle = window.setTimeout(this.connectionPing, this.pingInterval));
    });
    n(this, "connectionPing", () => {
      this.pongHandle = window.setTimeout(this.connectionPongMissed, this.pongInterval), this.sendMessage("PING"), this.pingHandle = null;
    });
    n(this, "connectionPongMissed", () => {
      console.log("pong missing - connection problem."), this.pongHandle = null;
    });
    this.OnMessageReceived = new d(), this.OnSocketConnected = new d(), this.OnSocketDisconnected = new d(), this.OnAuthenticationFailed = new d(), this.OnSocketError = new d();
    const e = window.location;
    this.socket = null;
    let t = "wss";
    e.protocol == "http:" && (t = "ws"), this.requestPath = t + "://" + e.host + "/ws";
  }
}
let D = (s) => s;
function X(s) {
  D = s;
}
function p(s, ...e) {
  return D(s, ...e);
}
let S, m;
var v = /* @__PURE__ */ ((s) => (s[s.OK = 0] = "OK", s[s.Cancel = 1] = "Cancel", s[s.Yes = 2] = "Yes", s[s.No = 3] = "No", s[s.Close = 4] = "Close", s))(v || {});
const _ = {
  0: {
    Id: "OK",
    CaptionKey: "fw4.MessageBox.Buttons.OK",
    Type: 0,
    IsPrimary: !0
  },
  1: {
    Id: "Cancel",
    CaptionKey: "fw4.MessageBox.Buttons.Cancel",
    Type: 1,
    IsPrimary: !1
  },
  2: {
    Id: "Yes",
    CaptionKey: "fw4.MessageBox.Buttons.Yes",
    Type: 2,
    IsPrimary: !0
  },
  3: {
    Id: "No",
    CaptionKey: "fw4.MessageBox.Buttons.No",
    Type: 3,
    IsPrimary: !1
  },
  4: {
    Id: "Close",
    CaptionKey: "fw4.MessageBox.Buttons.Close",
    Type: 4,
    IsPrimary: !1
  }
}, C = q("fw4Store", {
  state: () => ({
    MessageBox: {
      Title: "",
      Content: "",
      Display: !1,
      ButtonList: []
    },
    DocumentViewer: {
      Title: "",
      Url: "",
      Display: !1
    },
    ExportFactory: {
      Url: ""
    }
  }),
  actions: {
    async DeleteFile(s) {
      return new Promise((e, t) => {
        const o = (i) => {
          i.Success === !0 ? e(!0) : t(!1);
        };
        k.executeMethod("fw4.DeleteFile", {
          FileId: s
        }, o);
      });
    },
    async ShowMessageBox(s, e, t) {
      return this.MessageBox.Title = s, this.MessageBox.Content = e, this.MessageBox.ButtonList = t.map((o) => ({
        ...o,
        Caption: o.CaptionKey ? p(o.CaptionKey) : o.Caption
      })), this.MessageBox.Display = !0, new Promise((o, i) => {
        S = o;
      });
    },
    MessageBoxButtonClicked(s) {
      this.MessageBox.Display = !1, S(s), S = void 0;
    },
    async ShowDocumentStatic(s, e) {
      return this.DocumentViewer.Url = s, this.DocumentViewer.Title = e, this.DocumentViewer.Display = !0, new Promise((t, o) => {
        m = t;
      });
    },
    DocumentViewerClose() {
      this.DocumentViewer.Display = !1, this.DocumentViewer.Url = "", m(), m = void 0;
    },
    async ShowReport(s) {
      this.DocumentViewer.Url = "";
      const e = (t) => {
        t.Success === !0 && (this.DocumentViewer.Title = s.Title, this.DocumentViewer.Display = !0, this.DocumentViewer.Url = "/appinvoke/reporting?guid=" + t.ReportGuid + "&fn=" + s.FileName);
      };
      return k.executeMethod("fw4.ReportPayloadSet", {
        MethodName: s.MethodName,
        Parameters: JSON.stringify(s.Parameters)
      }, e), new Promise((t, o) => {
        m = t;
      });
    },
    async ExportData(s) {
      const e = (t) => {
        t.Success === !0 && (this.ExportFactory.Url = "/appinvoke/export?guid=" + t.ExportGuid + "&fn=" + s.FileName);
      };
      return k.executeMethod("fw4.ExportPayloadSet", {
        MethodName: s.MethodName,
        Parameters: JSON.stringify(s.Parameters)
      }, e), new Promise((t, o) => {
        m = t;
      });
    }
  }
});
class M {
  constructor() {
    n(this, "OnStreamDataReceived");
    n(this, "OnWebSocketConnected");
    n(this, "OnWebSocketDisconnected");
    n(this, "OnWebSocketAuthenticationFailed");
    n(this, "WebSocketConnected", !1);
    n(this, "webSocketClient");
    n(this, "methodId");
    n(this, "ExecutionQueue");
    n(this, "connectWebSockets", async () => {
      this.webSocketClient = new A(), this.webSocketClient.OnMessageReceived.AddCallback(this.webSocketReceive), this.webSocketClient.OnSocketConnected.AddCallback(this.socketConnected), this.webSocketClient.OnSocketDisconnected.AddCallback(this.socketDisconnected), this.webSocketClient.OnAuthenticationFailed.AddCallback(this.authenticationFailed), await this.webSocketClient.connectSocket();
    });
    n(this, "disconnectWebSockets", () => {
      this.webSocketClient.shouldReconnect = !1, this.webSocketClient.disconnectSocket();
    });
    n(this, "executeMethod", (e, t, o) => {
      var a, c;
      this.methodId++;
      const i = {
        methodId: this.methodId,
        methodName: e,
        parameters: t,
        receiveDelegate: o
      };
      if (this.ExecutionQueue[this.methodId] = i, (a = this.webSocketClient) != null && a.isConnected)
        (c = this.webSocketClient) == null || c.sendMessage(JSON.stringify(i));
      else {
        const r = new O();
        r.OnMessageReceived.AddCallback(this.httpRequestReceive), r.makeRequest(JSON.stringify(i));
      }
    });
    n(this, "executeMethodUpload", (e, t, o, i = {}) => {
      this.methodId++;
      const a = {
        methodId: this.methodId,
        methodName: o ?? "fileUpload",
        parameters: {},
        receiveDelegate: t
      };
      this.ExecutionQueue[this.methodId] = a;
      const c = new O();
      c.OnMessageReceived.AddCallback(this.httpRequestReceive);
      var r = new FormData();
      Array.from(e).forEach((u) => {
        r.append(u.name, u);
      }), r.append("MethodId", this.methodId.toString()), r.append("MethodName", o ?? ""), r.append("MethodParams", JSON.stringify(i)), c.makeUpload(r);
    });
    n(this, "socketConnected", () => {
      this.OnWebSocketConnected.Execute(), this.WebSocketConnected = !0;
    });
    n(this, "socketDisconnected", () => {
      this.OnWebSocketDisconnected.Execute(), this.WebSocketConnected = !1;
    });
    n(this, "authenticationFailed", () => {
      var e;
      this.OnWebSocketAuthenticationFailed.Execute(), (e = this.webSocketClient) == null || e.disconnectSocket();
    });
    n(this, "blobLoad", (e) => {
      let t = document.createElement("a");
      t.download = e.FileName;
      let o = new Blob([e.Data], { type: e.ContentType }), i = new FileReader();
      i.readAsDataURL(o), i.onload = function() {
        t.href = i.result, t.click();
      };
    });
    n(this, "executeLoadMethod", (e, t) => {
      this.executeMethod(e, t, this.blobLoad);
    });
    n(this, "webSocketReceive", (e) => {
      const t = JSON.parse(e);
      t.methodId > 0 ? this.executeReceiveDelegate(t) : this.OnStreamDataReceived.Execute(t.returnObject);
    });
    n(this, "getNewMethodId", () => (this.methodId++, this.methodId));
    n(this, "httpRequestReceive", (e) => {
      const t = JSON.parse(e);
      if (t.methodId > 0)
        this.executeReceiveDelegate(t);
      else
        throw new L(0, "Streaming is not allowed over HttpRequest");
    });
    n(this, "executeReceiveDelegate", (e) => {
      const t = this.ExecutionQueue[e.methodId].receiveDelegate;
      if (delete this.ExecutionQueue[e.methodId], e.errorStatus != "") {
        const o = C();
        switch (e.errorStatus) {
          case "INTERNAL_ERROR":
            o.ShowMessageBox(p("fw4.Communication.ErrorTitle"), p("fw4.Communication.InternalErrorText"), [
              _[v.OK]
            ]);
            break;
          case "AUTHTOKEN_INVALID":
            o.ShowMessageBox(p("fw4.Communication.AuthTitle"), p("fw4.Communication.AuthError"), [
              _[v.OK]
            ]);
            break;
        }
      } else t != null && t(e.returnObject);
    });
    this.methodId = 0, this.OnStreamDataReceived = new d(), this.OnWebSocketConnected = new d(), this.OnWebSocketDisconnected = new d(), this.OnWebSocketAuthenticationFailed = new d(), this.webSocketClient = null, this.ExecutionQueue = {};
  }
  static get Instance() {
    return this.singletonInstance || (this.singletonInstance = new this());
  }
  isWebSocketConnected() {
    var e;
    return ((e = this.webSocketClient) == null ? void 0 : e.isConnected) ?? !1;
  }
  async executeMethodAsync(e, t) {
    return new Promise((o, i) => {
      const a = (c) => {
        try {
          o(c);
        } catch (r) {
          i(r);
        }
      };
      this.executeMethod(e, t, a);
    });
  }
}
n(M, "singletonInstance");
const k = M.Instance, N = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Icon'%3e%3cpath%20id='Vector'%20d='M12%204L4%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_2'%20d='M4%204L12%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e", W = { class: "dialog__heading" }, U = { class: "dialog__body" }, K = ["src"], Z = /* @__PURE__ */ R({
  __name: "DocumentViewer",
  setup(s) {
    const e = C();
    return (t, o) => {
      const i = f("v-btn"), a = f("v-dialog");
      return w(), b(a, {
        persistent: "",
        modelValue: l(e).DocumentViewer.Display,
        class: "dialog-preview"
      }, {
        default: g(() => [
          E(i, {
            class: "btn btn--default-fill btn--round btn--sm ml-auto",
            onClick: o[0] || (o[0] = (c) => l(e).DocumentViewerClose())
          }, {
            default: g(() => [...o[1] || (o[1] = [
              h("img", {
                src: N,
                alt: "Close"
              }, null, -1)
            ])]),
            _: 1
          }),
          h("div", W, x(l(e).DocumentViewer.Title), 1),
          h("div", U, [
            h("iframe", {
              ref: "iframe",
              src: l(e).DocumentViewer.Url,
              frameBorder: "0"
            }, null, 8, K)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}), J = ["src"], ee = /* @__PURE__ */ R({
  __name: "ExportFactory",
  setup(s) {
    const e = C();
    return (t, o) => (w(), I("iframe", {
      ref: "export_iframe",
      src: l(e).ExportFactory.Url,
      frameBorder: "0",
      style: { display: "none" }
    }, null, 8, J));
  }
}), j = { class: "dialog__heading" }, $ = ["innerHTML"], Q = { class: "dialog__footer" }, te = /* @__PURE__ */ R({
  __name: "MessageBox",
  setup(s) {
    const e = C();
    return (t, o) => {
      const i = f("v-btn"), a = f("v-dialog");
      return w(), b(a, {
        persistent: "",
        modelValue: l(e).MessageBox.Display
      }, {
        default: g(() => [
          E(i, {
            onClick: o[0] || (o[0] = (c) => l(e).MessageBox.Display = !1),
            class: "btn btn--default-fill btn--round btn--sm ml-auto"
          }, {
            default: g(() => [...o[1] || (o[1] = [
              h("img", {
                src: N,
                alt: "Close"
              }, null, -1)
            ])]),
            _: 1
          }),
          h("div", j, x(l(e).MessageBox.Title), 1),
          h("div", {
            class: "dialog__body",
            innerHTML: l(e).MessageBox.Content
          }, null, 8, $),
          o[2] || (o[2] = h("hr", { class: "hr mb-8" }, null, -1)),
          h("div", Q, [
            (w(!0), I(T, null, V(l(e).MessageBox.ButtonList, (c, r) => (w(), b(i, {
              flat: "",
              class: B(c.IsPrimary ? "btn btn--primary-fill" : "btn btn--default-fill"),
              onClick: (u) => l(e).MessageBoxButtonClicked(c.Id)
            }, {
              default: g(() => [
                F(x(c.Caption), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))), 256))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
export {
  M as CommunicationClient,
  Z as DocumentViewer,
  ee as ExportFactory,
  te as MessageBox,
  v as MessageBoxButtonType,
  _ as MessageBoxPredefinedButtons,
  k as commClient,
  X as setTranslator,
  C as useFw4Store
};
//# sourceMappingURL=fw4-library.es.js.map
